﻿import ct from 'countries-and-timezones';
import Constant from 'utils/constants';

export const getTimeZones = () => {
  const timeZones = ct.getAllTimezones();
  return Object.values(timeZones).filter((tz) => {
    return Constant.timeZones.includes(tz.name);
  });
};
